import { render, staticRenderFns } from "./ChatBox.vue?vue&type=template&id=75b936d7"
import script from "./ChatBox.vue?vue&type=script&lang=js"
export * from "./ChatBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinnerComment from 'quasar/src/components/spinner/QSpinnerComment.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QScrollObserver from 'quasar/src/components/scroll-observer/QScrollObserver.js';
import QResizeObserver from 'quasar/src/components/resize-observer/QResizeObserver.js';
import QChatMessage from 'quasar/src/components/chat/QChatMessage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QField from 'quasar/src/components/field/QField.js';
import QEditor from 'quasar/src/components/editor/QEditor.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../website/node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QCardSection,QInnerLoading,QSpinnerComment,QScrollArea,QScrollObserver,QResizeObserver,QChatMessage,QBtn,QMenu,QList,QItem,QItemSection,QIcon,QBadge,QSeparator,QField,QEditor});qInstall(component, 'directives', {ClosePopup});
